/**
 * 父页面与iframe交互用的
 */
export default class {
  constructor(iframeDom){
    this.contentWindow = iframeDom.contentWindow
    this._messages = {};
    
    //监听消息
    window.addEventListener('message', e => {
      if (e.source !== this.contentWindow) {
        return;
      }
    
      //解析数据
      var res;
      try {
        if (e.data && typeof e.data === 'string') {
          res = JSON.parse(e.data);
        }
      } catch (e) {
      }
    
      if (res) {
        this._handleMessage(res.action, res.data);
      }
    })
  }
  
  on(action, handler, self) {
    var _messages = this._messages
    _messages[action] = _messages[action] || [];
    _messages[action].push({
      handler: handler,
      self: self
    });
  }
  
  off(action, handler) {
    var _messages = this._messages
    if (!_messages[action]) {
      return;
    } else if (!handler) {
      delete _messages[action];
    } else {
      for (var i = _messages[action].length - 1; i >= 0; i--) {
        var obj = _messages[action][i];
        if (obj.handler === handler) {
          _messages[action].splice(i, 1);
        }
      }
      if (!_messages[action].length) {
        delete _messages[action];
      }
    }
  }
  
  _handleMessage(action, data) {
    var _messages = this._messages
    _messages[action] && _messages[action].forEach(function (obj) {
      obj.handler.call(obj.self || window, data);
    });
  }
  
  postMessage(data) {
    this.contentWindow.postMessage(JSON.stringify(data), "*");
  }
}

